import { render, staticRenderFns } from "./CheckboxComponent.vue?vue&type=template&id=6afeac9a"
import script from "./CheckboxComponent.vue?vue&type=script&lang=ts"
export * from "./CheckboxComponent.vue?vue&type=script&lang=ts"
import style0 from "./CheckboxComponent.vue?vue&type=style&index=0&id=6afeac9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports